<template>
  <div class="g-wrap job-wrap" v-if="jobList.length > 0">
    <div class="column-wrap">
      <job-card v-for="item in jobList" :data="item" :key="item.id"></job-card>
    </div>
  </div>
  <div v-else class="g-nodata"></div>
</template>

<script>
import JobCard from "../../admissionsHiring/components/JobCard";
import { getData } from "api/app";
export default {
  name: "panel-job",
  data() {
    return {
      baseData: {
        content: "",
        id: "",
        pic: ""
      },
      mentorList: [],
      courseList: [],
      relativeList: [],
      jobList: [],
      proList: [],
      id: ""
    };
  },
  created() {
    this.init();
  },
  components: {
    [JobCard.name]: JobCard
  },
  methods: {
    loadData() {
      var jobQueryparam = {
        name: "RecruitJob",
        top: 8,
        params: [{ Key: "Enterprise", Value: this.id, CompareType: "EqualTo" }]
      };
      var recruitJobQueryParam = {
        name: "RecruitJob",
        top: 4,
        params: [
          {
            Key: "Enterprise",
            Value: this.id,
            CompareType: "EqualTo"
          }
        ]
      };
      getData(recruitJobQueryParam).then(res1 => {
        //招聘岗位
        const arr = [];
        var ids = [];
        res1.forEach(e => {
          ids.push(e.JobId);
        });
        var jobQueryParam = {
          name: "Job",
          params: [
            {
              Key: "Id",
              Value: ids.join(","),
              CompareType: "In"
            }
          ]
        };
        getData(jobQueryParam).then(res2 => {
          res1.forEach(item => {
            arr.push({
              PostName: item.JobName,
              Salary: res2.find(o => o.Id == item.JobId).Salary,
              Enterprise: item.Enterprise,
              IssueTime: item.CreatedTime,
              HiringCount: item.RecruitCount,
              Id: item.Id
            });
            this.jobList = arr || [];
          });
        });
      });
      getData(jobQueryparam).then(res => {
        if (res) {
          res.forEach(element => {
            this.jobList.push({
              Id: element.Id,
              PostName: element.Name,
              Salary: element.Salary,
              HiringCount: element.HiringCount,
              Enterprise: element.Enterprise,
              EnterpriseId: element.EnterpriseId
            });
          });
        }
      });
    },
    init() {
      this.id = this.$route.params.id;
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.job-wrap {
  padding: 40px 0;
  .column-wrap {
    flex-wrap: wrap;
    display: flex;
    justify-content: space-between;
  }
}
</style>
